import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { Check } from "lucide-react"

import { cn } from "@/lib/utils"

const Checkbox = React.forwardRef(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      "peer h-4 w-4 shrink-0 rounded-sm border border-[#CBD5E1] bg-[#F5F7FA] shadow focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#2F8BFB] disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-[#2F8BFB] data-[state=checked]:text-white data-[state=checked]:border-[#2F8BFB]",
      className
    )}
    {...props}>
    <CheckboxPrimitive.Indicator className={cn("flex items-center justify-center text-current")}>
      <Check className="h-4 w-4" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
